const ROOT_FIELDS = [
  "experienceDefaults",
  "business",
  "navigation",
  "hero",
  "catalog",
  "about",
  "highlightsIntro",
  "highlights",
  "imageCarousel",
  "testimonials",
  "contact",
  "footer",
  "messages",
  "notifications",
  "widgets",
  "pages",
  "theme",
  "seo",
  "sections",
  "layout",
];

function clone(value) {
  if (typeof structuredClone === "function") return structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}

export function settingsPayload(form = {}, productsEnabled = true) {
  const payload = { schemaVersion: 26 };

  ROOT_FIELDS.forEach((field) => {
    if (form[field] !== undefined) payload[field] = clone(form[field]);
  });

  if (!productsEnabled) {
    payload.navigation = {
      ...(payload.navigation || {}),
      showProductsLink: false,
      showCart: false,
    };
    payload.sections = {
      ...(payload.sections || {}),
      showProducts: false,
      showFeatured: false,
      showCategories: false,
      showBrands: false,
      showSpotlight: false,
    };
  }

  return payload;
}
